var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bijia-privacy-page"},[_c('div',{staticClass:"section privacy-content-section"},[_c('div',{staticClass:"container"},[_c('el-card',{staticClass:"privacy-card",attrs:{"shadow":"hover"}},[_c('div',{staticClass:"privacy-section"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }